export enum ServiceType {
  SCHEDULED = 'SCHEDULED',
  PER_REQUEST = 'PER_REQUEST',
  ADDITIONAL = 'ADDITIONAL',
  COMMUNE = 'COMMUNE',
}
